module.exports = __webpack_public_path__ + "img/xlsx-template.205f6ef1.png";